import { render } from "./InventoryOverviewChart.vue?vue&type=template&id=75706682&scoped=true"
import script from "./InventoryOverviewChart.vue?vue&type=script&lang=js"
export * from "./InventoryOverviewChart.vue?vue&type=script&lang=js"

import "./InventoryOverviewChart.vue?vue&type=style&index=0&id=75706682&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-75706682"

export default script